import { configureStore } from "@reduxjs/toolkit";
import apiReducer from "./api/apiSlice";

export const store = configureStore({
  reducer: { [apiReducer.reducerPath]: apiReducer.reducer },
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiReducer.middleware),
});
